export const hasuraPath = '/v1/graphql';
